import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { recordRumPageView } from "./rum";

// Records one RUM page view per navigation, using the sanitized route shape
// (never the resolved patient id). Renders nothing; mount inside the Router.
export default function RumRouteTracker() {
  const location = useLocation();
  useEffect(() => {
    recordRumPageView(location.pathname);
  }, [location.pathname]);
  return null;
}
